import React, { useEffect, useState } from "react";
import { Icon } from "./icons";
import "./ManageDevelopment.css";

const API_URL = process.env.REACT_APP_API_URL ||
  "https://backend-9i6n.onrender.com";

const statusMeta = (p) => {
  if (p.status === "Completed" || p.progress >= 100)
    return { label: "पूर्ण", cls: "gp-badge-green" };
  if (p.progress > 0) return { label: "सुरू", cls: "gp-badge-amber" };
  return { label: "नियोजित", cls: "gp-badge-blue" };
};

const ManageDevelopment = () => {
  const [projects, setProjects] = useState([]);
  const [images, setImages] = useState([]);
  const [search, setSearch] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    projectName: "",
    description: "",
    progress: "",
    fundsUsed: "",
  });

  const token = localStorage.getItem("token");

  // ================= FETCH PROJECTS =================
  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const res = await fetch(`${API_URL}/api/development`);
      const data = await res.json();
      setProjects(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Fetch failed", err);
    }
  };

  // ================= INPUT CHANGE =================
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ================= ADD / UPDATE =================
  const submitProject = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (editingId) {
        // UPDATE PROJECT
        await fetch(`${API_URL}/api/development/${editingId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            description: form.description,
            progress: Number(form.progress),
            fundsUsed: form.fundsUsed,
          }),
        });
      } else {
        // ADD PROJECT
        const formData = new FormData();
        Object.keys(form).forEach((key) => {
          formData.append(key, form[key]);
        });

        for (let i = 0; i < images.length; i++) {
          formData.append("images", images[i]);
        }

        await fetch(`${API_URL}/api/development`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });
      }

      resetForm();
      fetchProjects();
    } catch (error) {
      console.error("Submit failed", error);
      alert("प्रकल्प जतन करता आला नाही");
    } finally {
      setLoading(false);
    }
  };

  // ================= EDIT =================
  const startEdit = (project) => {
    setEditingId(project._id);
    setForm({
      projectName: project.projectName,
      description: project.description,
      progress: project.progress,
      fundsUsed: project.fundsUsed,
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ================= MARK COMPLETED =================
  const markCompleted = async (id) => {
    await fetch(`${API_URL}/api/development/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ progress: 100 }),
    });

    fetchProjects();
  };

  // ================= RESET =================
  const resetForm = () => {
    setEditingId(null);
    setForm({
      projectName: "",
      description: "",
      progress: "",
      fundsUsed: "",
    });
    setImages([]);
  };

  const shown = projects.filter((p) => {
    if (!search.trim()) return true;
    const q = search.trim().toLowerCase();
    return (
      p.projectName?.toLowerCase().includes(q) ||
      p.description?.toLowerCase().includes(q)
    );
  });

  return (
    <div className="admin-page">
      <div className="gp-page-head">
        <div>
          <h1>विकास कामे</h1>
          <p>गावातील पायाभूत सुविधा व विकास कामांची प्रगती नोंदवा</p>
        </div>
      </div>

      {/* ADD / UPDATE FORM */}
      <div className="gp-card dev-form-card">
        <h3 className="dev-form-title">
          {editingId ? "प्रकल्प संपादित करा" : "नवीन प्रकल्प जोडा"}
        </h3>

        <form className="dev-form-grid" onSubmit={submitProject}>
          <input
            className="gp-input"
            name="projectName"
            placeholder="प्रकल्पाचे नाव"
            value={form.projectName}
            onChange={handleChange}
            required
            disabled={!!editingId}
          />

          <textarea
            className="gp-textarea"
            name="description"
            placeholder="वर्णन"
            value={form.description}
            onChange={handleChange}
          />

          <input
            className="gp-input"
            name="fundsUsed"
            placeholder="वापरलेला निधी (₹)"
            value={form.fundsUsed}
            onChange={handleChange}
          />

          <input
            className="gp-input"
            type="number"
            name="progress"
            placeholder="प्रगती %"
            value={form.progress}
            onChange={handleChange}
            min="0"
            max="100"
            required
          />

          {!editingId && (
            <input
              className="gp-input"
              type="file"
              multiple
              onChange={(e) => setImages(e.target.files)}
              style={{ paddingTop: 8 }}
            />
          )}

          <div className="dev-form-actions">
            <button type="submit" className="gp-btn gp-btn-green" disabled={loading}>
              {loading ? (
                <span className="gp-spinner" />
              ) : editingId ? (
                "प्रकल्प अद्ययावत करा"
              ) : (
                <>
                  <Icon.plus size={16} /> प्रकल्प जोडा
                </>
              )}
            </button>

            {editingId && (
              <button
                type="button"
                className="gp-btn gp-btn-ghost"
                onClick={resetForm}
                disabled={loading}
              >
                रद्द करा
              </button>
            )}
          </div>
        </form>
      </div>

      {/* TOOLBAR */}
      <div className="gp-toolbar" style={{ marginTop: 26 }}>
        <div className="gp-search-box">
          <Icon.search size={16} />
          <input
            placeholder="काम शोधा…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <span className="gp-toolbar-count">एकूण {shown.length} कामे</span>
      </div>

      {/* PROJECT LIST */}
      {projects.length === 0 ? (
        <div className="gp-empty">कोणतेही विकास काम आढळले नाही. वरील फॉर्ममधून पहिले काम जोडा!</div>
      ) : shown.length === 0 ? (
        <div className="gp-empty">या शोधासाठी कोणतेही काम सापडले नाही</div>
      ) : (
        <div className="gp-record-grid">
          {shown.map((p) => {
            const meta = statusMeta(p);
            return (
              <div className="gp-record-card" key={p._id}>
                <div className="gp-record-top">
                  <span className={`gp-badge ${meta.cls}`}>{meta.label}</span>
                </div>

                <h3 className="gp-record-title">{p.projectName}</h3>
                {p.description && <p className="gp-record-desc">{p.description}</p>}

                <div>
                  <div className="gp-progress-row">
                    <span>प्रगती</span>
                    <span style={{ color: "var(--gp-green)" }}>{p.progress}%</span>
                  </div>
                  <div className="gp-progress-track">
                    <div className="gp-progress-fill" style={{ width: `${p.progress}%` }} />
                  </div>
                </div>

                <div className="gp-record-stat">
                  वापरलेला निधी: ₹{p.fundsUsed || "N/A"}
                </div>

                <div className="gp-record-foot">
                  <span />
                  {p.status !== "Completed" ? (
                    <div className="gp-record-actions">
                      <button className="gp-icon-btn" title="संपादित करा" onClick={() => startEdit(p)}>
                        <Icon.edit size={15} />
                      </button>
                      <button
                        className="gp-btn gp-btn-green gp-btn-sm"
                        onClick={() => markCompleted(p._id)}
                      >
                        <Icon.check size={14} /> पूर्ण करा
                      </button>
                    </div>
                  ) : (
                    <span className="gp-badge gp-badge-green">
                      <Icon.check size={12} /> पूर्ण झाले
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ManageDevelopment;
